import { styled } from '@mui/material/styles';
import Checkbox from '@/components/Checkbox/Checkbox';

const TableCheckbox = styled(Checkbox)({
  padding: '0',
});

export default TableCheckbox;
